import axios from 'axios';
import {ApiUrl} from 'app/static/apiUrls';

export const socialLoginAvailability = () => axios.get(ApiUrl.socialAvailability).then(({data}) => data.is_available);
